import { render, staticRenderFns } from "./confirmation-modal.vue?vue&type=template&id=64b185f0&scoped=true&"
import script from "./confirmation-modal.vue?vue&type=script&lang=js&"
export * from "./confirmation-modal.vue?vue&type=script&lang=js&"
import style0 from "./confirmation-modal.vue?vue&type=style&index=0&id=64b185f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b185f0",
  null
  
)

export default component.exports